import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var PreviewImage =
/** @class */
function (_super) {
  __extends(PreviewImage, _super);

  function PreviewImage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PreviewImage.prototype.onClick = function (image) {
    if (this.src) {
      // 预览图片
      wx.previewImage({
        // 当前预览的图片http链接
        current: image,
        // 需要预览的图片http链接列表
        urls: this.src
      });
    }
  };

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], PreviewImage.prototype, "src", void 0);

  PreviewImage = __decorate([Component({
    name: 'PreviewImageList'
  })], PreviewImage);
  return PreviewImage;
}(Vue);

export default PreviewImage;